export default __webpack_public_path__ + "static/media/supportForm.711c88ae.svg";